var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-container',[_c('b-row',[_c('b-col',{staticClass:"mb-3 mx-auto",attrs:{"sm":"9","md":"7","lg":"5"}},[_c('b-img',{staticClass:"logo mb-5 mx-auto d-block",attrs:{"src":"/Icons/SVG ICONS-08.svg","fluid":""}}),_c('password-validator',{ref:"passwordForm",on:{"submit":_vm.handlePasswordChange}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }